import { useApiClient } from '@esnafai/shared/api';
import { useSession } from '@esnafai/shared/auth';

// GET /home, read by the shell for the Bekleyenler badge and the paused_all banner (merchant screens §2, §4.4); the
// stream's cache actions refetch it. Off once signed out, so a logout leaves nothing to refetch.
export function useHome() {
  const { $api } = useApiClient();
  const { principal } = useSession();
  return $api.useQuery('get', '/api/home', {}, { enabled: principal !== null });
}
